import { Control } from './control';

export class StickySecondaryNav extends Control {

    public static selector: string = ".secondary-nav";

    constructor(containerElement: Element) {
        super(containerElement);

        // events
        this.buildNavigation();
        this.setupScrollObserver();
    }

    private buildNavigation(): void {
        const headings = document.querySelectorAll<HTMLElement>('.grid h2');
        const navList = document.querySelector('.secondary-nav ul');

        if (!headings.length || !navList) return;

        const fragment = document.createDocumentFragment();

        headings.forEach((heading, index) => {
            const id = heading.id || `Heading${index}`;
            heading.id = id;
            const li = document.createElement('li');
            const anchor = document.createElement('a');
            anchor.href = `#${id}`;
            anchor.textContent = heading.textContent || 'Untitled';
            li.appendChild(anchor);
            fragment.appendChild(li);
        });
        navList.prepend(fragment);
    }

    private setupScrollObserver(): void {
        const highlightConfig: IntersectionObserverInit = {
            rootMargin: '-150px 0px -55%'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    this.updateActiveLink(id);
                }
            });
        }, highlightConfig);

        document.querySelectorAll('.grid h2').forEach(heading => {
            observer.observe(heading);
        });
    }
    
    private updateActiveLink(targetId: string): void {
        // Remove currently active class
        const currentActive = document.querySelector('.secondary-nav li a.active');
        currentActive?.classList.remove('active');

        // Add active class to new target
        const nextActive = document.querySelector(`.secondary-nav li a[href="#${targetId}"]`);
        nextActive?.classList.add('active');
    }
}




